export interface PlannerCalendarControlsSettings {
  showTasks: boolean
  showScheduledTasks: boolean
  showCalendarAppointments: boolean
  showTimeEntries: boolean
  showPlannedTasks: boolean
  showTimeBookings: boolean
  showDueDateOnlyTasks: boolean
}

export const defaultPlannerCalendarControlsSettings = {
  showTasks: true,
  showScheduledTasks: true,
  showCalendarAppointments: true,
  showTimeEntries: true,
  showPlannedTasks: true,
  showTimeBookings: true,
  showDueDateOnlyTasks: true
}
